var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFrame(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.5448 13.7518L11.2168 10.2863C12.0728 9.26949 12.542 7.98231 12.5413 6.65249C12.5413 3.53576 10.0086 1 6.89566 1C3.78269 1 1.25 3.53576 1.25 6.65249C1.25 9.76923 3.78269 12.305 6.89566 12.305C8.06431 12.305 9.17798 11.9521 10.1301 11.2821L13.4834 14.7739C13.6236 14.9196 13.8121 15 14.0141 15C14.2053 15 14.3867 14.927 14.5244 14.7943C14.665 14.6586 14.746 14.4727 14.7499 14.2773C14.7537 14.0818 14.6799 13.8929 14.5448 13.7518ZM6.89566 2.47456C9.19663 2.47456 11.0685 4.34873 11.0685 6.65249C11.0685 8.95625 9.19663 10.8304 6.89566 10.8304C4.59468 10.8304 2.72278 8.95625 2.72278 6.65249C2.72278 4.34873 4.59468 2.47456 6.89566 2.47456Z",
    fill: "#8F8F8F"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame);
export default __webpack_public_path__ + "static/media/Frame.8b46a37ef25c16d12f298c6aae1e2200.svg";
export { ForwardRef as ReactComponent };